module.exports = __webpack_public_path__ + "img/voxuy.61cb1ec6.svg";